/**
 * Pure helpers for the inline "request a new reset link" form on the
 * /auth/reset-password no-session branch.
 *
 * Kept dependency-free so they can be unit-tested with node:test without
 * pulling in a Supabase client, the DOM, or Next.js.
 */

/**
 * Lightweight RFC-ish email-shape guard. We're not trying to match the full
 * RFC 5322 grammar — Supabase will do real validation server-side. This is
 * only here to stop the obvious typo cases (no @, no TLD, internal spaces).
 *
 * Trims surrounding whitespace before checking so users pasting from email
 * clients with stray spaces aren't blocked.
 */
export function isValidEmailShape(input: string): boolean {
  const trimmed = input.trim();
  if (trimmed.length === 0) return false;
  // Single @, no whitespace, at least one dot in the domain part.
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed);
}

/**
 * Build the redirectTo URL passed to supabase.auth.resetPasswordForEmail.
 * Mirrors the convention used by AuthForm.tsx (forgot mode) so the two
 * surfaces converge on a single callback contract.
 */
export function buildResetRedirectUrl(origin: string): string {
  const cleanOrigin = origin.replace(/\/+$/, "");
  return `${cleanOrigin}/auth/callback?type=recovery`;
}
